export default "__VITE_ASSET__DSxqmJB0__"